import { render, staticRenderFns } from "./resetPass.vue?vue&type=template&id=91f82816&scoped=true&"
import script from "./resetPass.vue?vue&type=script&lang=js&"
export * from "./resetPass.vue?vue&type=script&lang=js&"
import style0 from "./resetPass.vue?vue&type=style&index=0&id=91f82816&scoped=true&lang=css&"
import style1 from "./resetPass.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f82816",
  null
  
)

component.options.__file = "resetPass.vue"
export default component.exports